import React, { useEffect } from 'react';
import './App.css';
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom';
import { AnalyticsUtils } from './utils/analytics.utils';
import { PreLoginService } from './services/pre-login.service';

const App: React.FC = () => {

  useEffect( () => {
    PreLoginService.init();
    const isBBAnalyticsAvailable = AnalyticsUtils.initializeBbAnalytics();
    if ( isBBAnalyticsAvailable ) {
      AnalyticsUtils.trackPage( `${ window.location.pathname }${ window.location.hash }` );
    }
  } );

  return (
    <BrowserRouter basename="about">
      <div>
        <Switch>
          {/* Home */ }
          <Route exact path='/'></Route>
          {/* With pre-selected document */ }
          <Route path='/:documentId'></Route>
          {/* Not Found - catch all */ }
          <Route>
            <Redirect to='/#/error'/>
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default App;
